module.exports = {
	"$id": "har.json#",
	"$schema": "http://json-schema.org/draft-06/schema#",
	"type": "object",
	"required": [
		"log"
	],
	"properties": {
		"log": {
			"$ref": "log.json#"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/har-schema/lib/har.json
// module id = 673
// module chunks = 0